module.exports = __webpack_public_path__ + "img/16.a6fe5c1f.jpg";